import React, { useCallback, useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import {
    getAdminPlExposureCricketAPI,
    getAllMatchesOddsCricketAPI,
    getBetActiveDeactiveCricketAPI,
    getClientBetsCricketAPI,
    getCricketEventDetailsAPI,
    getCricketOddsByMatchIdAPI,
    getFullBookClientBetsCricketAPI,
    getSettledFancyAPI,
} from "../service/cricket";
import {
    getLiveStreamingUrlAPI,
    getSportsScoreAPI,
    getBookMakerPositionAPI,
} from "../service/AuthService";
import moment from "moment";
import toast from "react-hot-toast";
import { useQuery } from "react-query";
import CustomScoreCard from "./components/CustomScoreCard";
import LiveStreamPlayer from "./components/LiveStreamPlayer";
// import LiveScoreCardPHP from "./components/LiveScoreCardPHP";


export default function MatchPosition() {
    const userData = useSelector((state) => state.account.userData);
    const [matchOdds, setMatchOdds] = useState(null);
    const [matchDetails, setMatchDetails] = useState(null);
    const location = useLocation();
    const [betFilter, setBetFilter] = useState("BOOKMAKER_ODDS_1");
    const [userBetStatus, setUserBetStatus] = useState(false);
    const [fancyBetStatus, setFancyBetStatus] = useState(false);
    const [settledFancy, setSettledFancy] = useState({});
    const [matchData, setMatchData] = useState(null);
    const [clientBets, setClientBets] = useState([]);
    const [betStatus, setBetStatus] = useState("MATCHED");
    const [bookmakerPosition, setBookmakerPosition] = useState([]);
    const [gameSettings_, setGameSettings_] = useState({});
    const [showLiveTv, setShowLiveTv] = useState(false);
    const [channelId, setChannelId] = useState(null);
    const [showLadder, setShowLadder] = useState(false);
    const [matches, setMatches] = useState([]);
    const [fullBookClients, setFullBookClientBets] = useState([]);
    const [showScore, setShowScore] = useState(false);
    const [positionModal, setPositionModal] = useState(null);

    const betStatusRef = useRef(betStatus);
    useEffect(() => { betStatusRef.current = betStatus; }, [betStatus]);



    const getAllMatches = async () => {
        const { response } = await getAllMatchesOddsCricketAPI();
        setMatches(response);
    };

    useEffect(() => {
        getAllMatches();
    }, []);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const params = useParams();
    var gameType = "cricket";
    var eventId = params?.id;
    var gameSettings = useSelector(
        (state) => state.gameData[gameType + "Settings"]
    );
    if (gameSettings && gameSettings[eventId]) {
        gameSettings = gameSettings[eventId];
    }
    const scoreData = useQuery("scoreData", () => getSportsScoreAPI(eventId), {
        refetchInterval: 4000,
    });
    const getBookMakerposition = async (uid) => {
        const { response, code } = await getBookMakerPositionAPI(eventId, uid);
        if (code == 200) {
            setBookmakerPosition(response);
        }
    };

    const getGameEventDetails = useCallback(async () => {
        const { response } = await getCricketEventDetailsAPI(eventId);
        setMatchDetails(response);
        return response;
    }, [eventId, gameType]);
    const getSettledFancy = async () => {
        const { response } = await getSettledFancyAPI(eventId);
        setSettledFancy(response);
    };
    useEffect(() => {
        getGameEventDetails();

        setGameSettings_(gameSettings[eventId]);
    }, [location.pathname]);

    const getCricketPlExposure = async () => {
        const { response, code } = await getAdminPlExposureCricketAPI(eventId);
        if (code == 200) {
            setMatchData(response);
        }
    };
    const getClientBets = async (betStatus_, isFancy) => {
        const { response } = await getClientBetsCricketAPI(
            eventId,
            location?.state?.isBookmaker == true
                ? false
                : location?.state?.isBookmaker == false
                    ? true
                    : false,
            betStatus_ ? betStatus_ : betStatus
        );
        if (response) {
            setClientBets(response);
        }
    };
    const getFullBookClientBets = async (betStatus_, isFancy) => {
        const { response } = await getFullBookClientBetsCricketAPI(
            eventId, false,
            betStatus_ ? betStatus_ : betStatus
        );
        if (response) {
            setFullBookClientBets(response);
        }
    };
    const getBetActiveDeactive = async () => {
        const { response } = await getBetActiveDeactiveCricketAPI(eventId);
        if (response) {
            setUserBetStatus(response?.betLock);
            setFancyBetStatus(response?.fancyLock);
        }
    };
    const getCricketOddsByMatchId = useCallback(async () => {
        const { response, code } = await getCricketOddsByMatchIdAPI(eventId);
        if (code != 200) {
            toast.error("Something went wrong");
            window.location.href = "/";
            return;
        }
        let response_ = {};
        response_[eventId] = response;
        setMatchOdds(response);
        dispatch({
            type: "gameData/setCricketOdds",
            payload: response_,
        });
    }, [eventId]);

    useEffect(() => {
        if (eventId) {
            getCricketPlExposure();
            getClientBets();
            getFullBookClientBets();
            let interval = setInterval(() => {
                getCricketPlExposure();
                getClientBets();
                getFullBookClientBets()
                getBetActiveDeactive();
                getSettledFancy();
            }, 5000);
            return () => clearInterval(interval);
        }
    }, [eventId, location?.state?.isBookmaker]);

    useEffect(() => {
        let interval = setInterval(() => {
            getCricketOddsByMatchId();
        }, 800);
        return () => clearInterval(interval);
    }, [eventId]);

    //   const getLiveStreamingUrl = async () => {
    //     let gameId = await getGameEventDetails();
    //     const { response } = await getLiveStreamingUrlAPI(gameId?.eventId);
    //     setChannelId(response);
    //   };
    //   useEffect(() => {
    //     getLiveStreamingUrl();
    //   }, [eventId]);

    return (
        <div className="content-wrapper">
            {/* Content Header (Page header) */}
            <section className="content-header">
                <div className="container-fluid">

                    <div className="row mb-2">
                        <div className="col-sm-6">
                            <h1 className="mb-3">Match Position</h1>
                            {userData.userType == 'SUPER_ADMIN' ? <>
                                <a className="mt-5"
                                    onClick={() =>
                                        navigate(
                                            `/agent/dashboard/matches/${matchDetails?.cricketId
                                            }/current_bets`,
                                            {
                                                state: { matchDetails },
                                            }
                                        )
                                    } >
                                    {/* <button className="btn btn-primary">
                                        View More Bets
                                    </button> */}
                                </a>
                            </> : null}
                        </div>
                        <div className="col-sm-6">
                            <ol className="breadcrumb float-sm-right">
                                <li className="breadcrumb-item">
                                    <a href="/">Home</a>
                                </li>
                                <li className="breadcrumb-item active">
                                    <a href="/game/inPlay">InPlay</a>
                                </li>
                            </ol>
                        </div>
                    </div>
                </div>
                {/* /.container-fluid */}
            </section>
            {/* Main content */}
            <section className="content">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-12">
                            <div className="card card-secondary text-center">
                                {/* <button

                                    onClick={() => setShowLiveTv(!showLiveTv)}
                                    className="btn btn-primary live_tv_btn"
                                >
                                    Live TV
                                </button> */}



                                <div className="card-body">

                                    <div className="col-12 d-flex justify-content-between px-sm-4 px-2 py-2">
                                        <span className="btn btn-primary float-left" onClick={() => setShowScore(!showScore)}
                                        // style={{ opacity: '0', pointerEvents: 'none' }}
                                        >{showScore ? 'Half Score' : 'Full Score'}</span>
                                        <span className="btn btn-success float-right" onClick={() => setShowLiveTv(!showLiveTv)}>Show Tv</span>
                                    </div>

                                    {showLiveTv && (
                                        <LiveStreamPlayer eventId={location?.state?.match?.eventId} />
                                        // <div className="toggletv">
                                        //   <iframe

                                        //     id="cricketScore"
                                        //     title="Match Score"
                                        //     className="iframestyle iframeheightControll"
                                        //     style={{ width: "100%", height: "300px", background: "#000" }}
                                        //     src={`https://apis.professorji.in/api/tv?eventId=${matchDetails?.eventId}&sport=cricket`}
                                        //   />
                                        // </div>
                                    )}

                                    <div style={{ height: `${showScore ? '130px' : '208px'}` }}>
                                        <iframe style={{ width: '100%', height :'208px' }} src={`https://cricket-scorecard-new.netlify.app/sixrunscore/${location?.state?.match?.eventId}`}  >
                                        </iframe>
                                    </div>


                                </div>
                                <div className="form-row">
                                    <div className="col-md-6">
                                        <table className="table table-bordered" id="mOdds">
                                            <thead>
                                                <tr>
                                                    <th> Team</th>
                                                    <th className="text-red" style={{ width: 40 }}>
                                                        {" "}
                                                        KHAI
                                                    </th>
                                                    <th className="text-blue" style={{ width: 40 }}>
                                                        {" "}
                                                        LAGAI
                                                    </th>
                                                    <th>
                                                        <b className="text-blue">PLUS</b>/
                                                        <b className="text-red">MINUS</b>
                                                    </th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {matchOdds &&
                                                    matchOdds?.bookMakerOdds[0]?.bm1?.oddDetailsDTOS.map(
                                                        (match, index) => (
                                                            <tr>
                                                                <td
                                                                    data-column="runner_name"
                                                                    className="bet-place-tbl-td active"
                                                                    style={{ textAlign: "left" }}
                                                                >
                                                                    <span
                                                                        onClick={() => {
                                                                            navigate(
                                                                                `/game/matchPosition/${eventId}/${match?.runnerName
                                                                                }/${matchOdds?.bookMakerOdds[0]?.bm1
                                                                                    ?.marketId}`,
                                                                                {
                                                                                    state: {
                                                                                        isBookmaker: true,
                                                                                        runnerName: match?.runnerName,
                                                                                    },
                                                                                }
                                                                            );
                                                                        }}
                                                                    >
                                                                        {match?.runnerName}
                                                                        {match?.remark && (
                                                                            <marquee style={{ color: 'red', background: '#8080802b' }}>{match.remark}</marquee>
                                                                        )}
                                                                        {(() => {
                                                                            const totalExposure = fullBookClients?.bets
                                                                                ?.flatMap((bet) => bet.upperLineExposure ?? [])
                                                                                .filter((item) => item.selectionName === match.runnerName)
                                                                                .reduce((sum, item) => sum + (parseFloat(item.exposure) || 0), 0) ?? 0;
                                                                            const color = totalExposure > 0 ? "green" : totalExposure < 0 ? "red" : "gray";
                                                                            return (
                                                                                <span className="d-block text-start" style={{ color }}>
                                                                                    Full Book: {totalExposure.toFixed(2)}
                                                                                </span>
                                                                            );
                                                                        })()}

                                                                    </span>
                                                                </td>

                                                                <td
                                                                    data-runner-sid="Multan Sultans  _1436644"
                                                                    data-column="back"
                                                                    className="MarketTable text-bold text-red bet-place-tbl-td first-runner-bet-odds-yes-value cursor-pointer "
                                                                    odd-val="1.27"
                                                                    market-id={1594789}
                                                                    runner-id={8933387}
                                                                    match-id={1436644}
                                                                    data-id="LAGAI"
                                                                    id="Match Winner_1436644_back_Multan Sultans  _1436644"
                                                                >
                                                                    {/* {match?.status == "ACTIVE" && */}
                                                                    {parseFloat(match?.back1 / 100).toFixed(2)}
                                                                    {/* } */}
                                                                </td>
                                                                <td
                                                                    data-runner-sid="Multan Sultans  _1436644"
                                                                    data-column="lay"
                                                                    className="text-bold text-blue MarketTable bet-place-tbl-td first-runner-bet-odds-no-value cursor-pointer "
                                                                    odd-val="1.29"
                                                                    market-id={1594789}
                                                                    runner-id={8933387}
                                                                    match-id={1436644}
                                                                    data-id="KHAI"
                                                                    id="Match Winner_1436644_lay_Multan Sultans  _1436644"
                                                                >
                                                                    {/* {match?.status == "ACTIVE" && */}
                                                                    {parseFloat(match?.lay1 / 100).toFixed(2)}
                                                                </td>
                                                                <td
                                                                    data-runner-sid="Multan Sultans  _1436644"
                                                                    data-column="position"
                                                                    className="bet-place-tbl-td  bet-val-cent"
                                                                    data-position={0.0}
                                                                >
                                                                    <b>
                                                                        {matchData
                                                                            ?.find(
                                                                                (item) =>
                                                                                    item.marketIdExternal ==
                                                                                    matchOdds?.bookMakerOdds[0]?.bm1?.marketId
                                                                            )
                                                                            ?.runnerPlExposureDTOS?.find(
                                                                                (pl) => pl.selectionId == match?.selectionId
                                                                            )?.exposure &&
                                                                            <span className={parseFloat(
                                                                                matchData
                                                                                    ?.find(
                                                                                        (item) =>
                                                                                            item.marketIdExternal ==
                                                                                            matchOdds?.bookMakerOdds[0]?.bm1
                                                                                                ?.marketId
                                                                                    )
                                                                                    ?.runnerPlExposureDTOS?.find(
                                                                                        (pl) => pl.selectionId == match?.selectionId
                                                                                    )?.exposure
                                                                            ) >= 0 ? 'text-blue mx-2' : 'text-red mx-2'}>
                                                                                {parseFloat(
                                                                                    matchData
                                                                                        ?.find(
                                                                                            (item) =>
                                                                                                item.marketIdExternal ==
                                                                                                matchOdds?.bookMakerOdds[0]?.bm1
                                                                                                    ?.marketId
                                                                                        )
                                                                                        ?.runnerPlExposureDTOS?.find(
                                                                                            (pl) => pl.selectionId == match?.selectionId
                                                                                        )?.exposure
                                                                                ).toFixed(2) || 0.00}
                                                                            </span>
                                                                        }
                                                                    </b>
                                                                </td>
                                                            </tr>
                                                        )
                                                    )}
                                            </tbody>

                                        </table>
                                    </div>
                                    <div className="col-md-6">
                                        <table className="table table-bordered" id="sOdds">
                                            <thead>
                                                <tr>
                                                    <th>Session</th>
                                                    <th className=" text-red">NOT</th>
                                                    <th className="text-blue">YES</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {matchOdds?.fancyOdds
                                                    ?.find(
                                                        (item) =>
                                                            item?.gameType?.toLocaleLowerCase() == "normal"
                                                    )
                                                    ?.oddDetailsDTOS?.map((match) => (
                                                        <>
                                                            {" "}
                                                            <tr
                                                                _ngcontent-ng-c2652263913=""
                                                                className="ng-star-inserted"
                                                            >
                                                                <td
                                                                    data-column="session_title"
                                                                    className="bet-place-tbl-td"
                                                                    style={{ textAlign: "left" }}
                                                                >
                                                                    <a
                                                                        _ngcontent-ng-c2652263913=""
                                                                        onClick={() => {

                                                                            let exposureData;

                                                                            for (
                                                                                let i = 0;
                                                                                i < matchData.length;
                                                                                i++
                                                                            ) {
                                                                                let fancyMarket = matchData[i];
                                                                                let market = matchOdds?.fancyOdds?.find(
                                                                                    (item) => item?.gameType == "Normal"
                                                                                );
                                                                                for (
                                                                                    let j = 0;
                                                                                    j < market?.oddDetailsDTOS.length;
                                                                                    j++
                                                                                ) {
                                                                                    let odd = market.oddDetailsDTOS[j];
                                                                                    if (
                                                                                        odd?.marketId ==
                                                                                        fancyMarket?.marketIdExternal
                                                                                    ) {
                                                                                        exposureData = {
                                                                                            ...fancyMarket,
                                                                                            title: odd.runnerName,
                                                                                        };
                                                                                        break;
                                                                                    }
                                                                                }
                                                                            }

                                                                            navigate(
                                                                                `/game/matchPosition/${eventId}/${match?.runnerName
                                                                                }/${match?.marketId}`,
                                                                                {
                                                                                    state: {
                                                                                        isBookmaker: false,
                                                                                        runnerName: match?.runnerName,
                                                                                    },
                                                                                }
                                                                            );
                                                                            setShowLadder(match);
                                                                            setPositionModal(exposureData);
                                                                        }}
                                                                        // onClick={() => {
                                                                        //     navigate(
                                                                        //         `/game/matchPosition/${eventId}/${match?.runnerName
                                                                        //         }/${match?.marketId}`,
                                                                        //         {
                                                                        //             state: {
                                                                        //                 isBookmaker: false,
                                                                        //                 runnerName: match?.runnerName,
                                                                        //             },
                                                                        //         }
                                                                        //     );
                                                                        // }}
                                                                        style={{
                                                                            // textDecoration: "underline",
                                                                            // color: "blue",
                                                                        }}
                                                                        className="team_name_link font_gridDisplay fancy_st_padding"
                                                                    >
                                                                        <span _ngcontent-ng-c2652263913="">
                                                                            {match?.runnerName}
                                                                        </span>
                                                                        {match?.remark && (
                                                                            <marquee style={{ color: 'red', background: '#8080802b' }}>{match.remark}</marquee>
                                                                        )}
                                                                    </a>
                                                                    <span
                                                                        _ngcontent-ng-c2652263913=""
                                                                        className="d-block ps-2"
                                                                    >
                                                                        <span
                                                                            _ngcontent-ng-c2652263913=""
                                                                            className={
                                                                                matchData?.find(
                                                                                    (item) =>
                                                                                        match?.marketId == item.marketIdExternal
                                                                                )?.exposure >= 0
                                                                                    ? "plus_value"
                                                                                    : "mainus_value"
                                                                            }
                                                                        >
                                                                            {" "}
                                                                            {parseFloat(
                                                                                matchData?.find(
                                                                                    (item) =>
                                                                                        match?.marketId == item.marketIdExternal
                                                                                )?.exposure
                                                                                    ? matchData?.find(
                                                                                        (item) =>
                                                                                            match?.marketId ==
                                                                                            item.marketIdExternal
                                                                                    )?.exposure
                                                                                    : 0
                                                                            ).toFixed(2)}
                                                                        </span>
                                                                    </span>

                                                                </td>
                                                                <td
                                                                    className={`SessionTable  text-bold text-red bet-place-tbl-td first-runner-bet-odds-yes-value cursor-pointer ${(match?.status ==
                                                                        "SUSPENDED" ||
                                                                        match?.status == "Ball Running") &&
                                                                        "close-status"}`}
                                                                >
                                                                    <div className="cursor-pointer"
                                                                        onClick={() => {
                                                                            navigate(
                                                                                `/game/matchPosition/${eventId}/${match?.runnerName
                                                                                }/${match?.marketId}`,
                                                                                {
                                                                                    state: {
                                                                                        isBookmaker: false,
                                                                                        runnerName: match?.runnerName,
                                                                                    },
                                                                                }
                                                                            );
                                                                            setShowLadder(match);
                                                                        }}>
                                                                        {/* {match?.status != "SUSPENDED" &&
                                                                            match?.status != "Ball Running" && */}
                                                                        {parseInt(match?.lay1)}
                                                                        <br />
                                                                        {/* {match?.status != "SUSPENDED" &&
                                                                            match?.status != "Ball Running" && */}
                                                                        {parseFloat(match?.laySize1 / 100).toFixed(
                                                                            2
                                                                        )}
                                                                    </div>
                                                                </td>

                                                                <td
                                                                    className={`${(match?.status ==
                                                                        "SUSPENDED" ||
                                                                        match?.status == "Ball Running") &&
                                                                        "close-status"} SessionTable text-bold text-blue bet-place-tbl-td first-runner-bet-odds-no-value cursor-pointer`}
                                                                >
                                                                    <div className="cursor-pointer" onClick={() => {
                                                                        navigate(
                                                                            `/game/matchPosition/${eventId}/${match?.runnerName
                                                                            }/${match?.marketId}`,
                                                                            {
                                                                                state: {
                                                                                    isBookmaker: false,
                                                                                    runnerName: match?.runnerName,
                                                                                },
                                                                            }
                                                                        );
                                                                        setShowLadder(match);
                                                                    }}>
                                                                        {/* {match?.status != "SUSPENDED" &&
                                                                            match?.status != "Ball Running" && */}
                                                                        {parseInt(match?.back1)}
                                                                        <br />
                                                                        {/* {match?.status != "SUSPENDED" &&
                                                                            match?.status != "Ball Running" && */}
                                                                        {parseFloat(
                                                                            match?.backSize1 / 100
                                                                        ).toFixed(2)}
                                                                    </div>
                                                                </td>
                                                            </tr>
                                                            {/* {match?.remark && (
                                                                <tr>
                                                                    <marquee>{match?.remark}</marquee>
                                                                </tr>
                                                            )} */}
                                                        </>
                                                    ))}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                                <div className="row">
                                    <button
                                        style={{ margin: "10px", width: "100px" }}
                                        className="btn btn-primary"
                                        onClick={() =>
                                            (window.location.href = `/game/matchPosition/${eventId}`)
                                        }
                                    >
                                        Reset filter
                                    </button>
                                </div>
                                <div className="row">
                                    <div className="col-lg-10">
                                        <table className="table table-bordered table-striped table-hover table-responsive-md"
                                            id="matchBetsTable">
                                            <thead>
                                                <tr>
                                                    <th>SNo</th>
                                                    {params?.runnerName && (
                                                        <th>Run</th>
                                                    )}
                                                    <th>Rate</th>
                                                    <th>Amount</th>
                                                    <th>Mode</th>
                                                    <th>Team</th>
                                                    <th>Client</th>
                                                    <th>Agent</th>
                                                    {clientBets &&
                                                        clientBets?.bets &&
                                                        clientBets?.bets?.length > 0 &&
                                                        clientBets?.bets?.[0]?.upperLineExposure?.map(
                                                            (item, index) => (
                                                                <th key={index}>
                                                                    {clientBets?.bets[0]?.marketName !== "BOOKMAKER_ODDS_1"
                                                                        ? item?.selectionName === "YES"
                                                                            ? "NO"
                                                                            : "YES"
                                                                        : item?.selectionName}
                                                                </th>
                                                            )
                                                        )}

                                                    <th>Date &amp; Time</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {/**/}
                                                {clientBets?.bets
                                                    ?.filter((item) => {
                                                        // if (location?.state?.isBookmaker == true) {
                                                        //   return (
                                                        //     ?.runnerName == location?.state?.runnerName
                                                        //   );
                                                        // } else if
                                                        if (location?.state?.isBookmaker == false) {
                                                            return (
                                                                item?.marketName != "BOOKMAKER_ODDS_1" &&
                                                                item?.runnerName == location?.state?.runnerName
                                                            );
                                                        } else {
                                                            return item;
                                                        }
                                                    })
                                                    .map((item, index) => (
                                                        <>
                                                            <tr key={index}>
                                                                <td>{index + 1}</td>
                                                                {params?.runnerName &&
                                                                    <td>{item?.run}</td>}
                                                                <td>{item.rate}</td>

                                                                <td>{parseFloat(item.amount).toFixed(2)}</td>
                                                                <td
                                                                    style={{
                                                                        color:
                                                                            item?.marketName == "BOOKMAKER_ODDS_1"
                                                                                ? item?.back
                                                                                    ? "rgb(3, 117, 204)"
                                                                                    : "rgb(224, 60, 60)"
                                                                                : item?.back
                                                                                    ? "rgb(3, 117, 204)"
                                                                                    : "rgb(224, 60, 60)",
                                                                    }}
                                                                >
                                                                    {item?.marketName == "BOOKMAKER_ODDS_1"
                                                                        ? item?.back
                                                                            ? "KHAI"
                                                                            : "LAGAI"
                                                                        : item?.back
                                                                            ? "YES"
                                                                            : "NO"}
                                                                </td>
                                                                <td>{item.runnerName}</td>
                                                                <td>{item.userName}</td>
                                                                <td>{item?.agent}</td>
                                                                {item?.upperLineExposure?.map((item) => (
                                                                    <td
                                                                        style={{
                                                                            color:
                                                                                parseFloat(item?.exposure) < 0
                                                                                    ? "red"
                                                                                    : "green",
                                                                        }}
                                                                    >
                                                                        {parseFloat(item?.exposure).toFixed(2)}
                                                                    </td>
                                                                ))}

                                                                <td>
                                                                    {moment(item.placeDate + "Z").format(
                                                                        "YYYY-MM-DD HH:mm:ss"
                                                                    )}
                                                                </td>
                                                            </tr>
                                                        </>
                                                    ))}

                                                {/**/}
                                                {/**/}
                                            </tbody>
                                        </table>
                                    </div>
                                    <div className="col-lg-2">
                                        <table className="table table-bordered" id="sessionPosition">
                                            <thead>
                                                <tr>
                                                    <th>Runs</th>
                                                    <th>Amount</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {matchData &&
                                                    matchData
                                                        ?.find(
                                                            (item) =>
                                                                item.marketIdExternal == showLadder?.marketId
                                                        )
                                                        ?.runnerPlExposureDTOS?.sort(
                                                            (a, b) =>
                                                                parseInt(a.selectionName) -
                                                                parseInt(b.selectionName)
                                                        )
                                                        ?.map((item) => (
                                                            <tr>
                                                                <td>
                                                                    {item?.selectionName}
                                                                </td>
                                                                <td

                                                                    style={{
                                                                        color: item?.exposure < 0 ? "red" : "green",
                                                                    }}
                                                                >
                                                                    {parseFloat(item?.exposure).toFixed(2)}
                                                                </td>
                                                            </tr>
                                                        ))}
                                            </tbody>
                                        </table>
                                    </div>

                                </div>
                                {/* /.card-body */}
                            </div>
                            {/* /.card */}
                        </div>
                        {/* /.col */}
                    </div>
                    {/* /.row */}
                </div>
                {/* /.container-fluid */}
            </section >
            {/* /.content */}

        </div >
    )
}
